module.exports = __webpack_public_path__ + "static/media/BICNY.2be1c444.png";